










import { Vue, Component } from 'vue-property-decorator';
import Clasificador from '@/pantallas/Peajes/Clasificador/clasificador.vue';

@Component({
  components: { Clasificador },
})
export default class DashboardPantalla extends Vue {}
